import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { SideBar } from '../shared/component/sidebar/siderbar';
import { RoomNoService } from '../service/room-no.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import {
  getNowDateObject,
  getStreamNowDate
} from '../shared/tools/DateNowTime';
import { nowDate } from '../index/nowDate';
import { LanguageService } from '../service/language.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stay-info',
  templateUrl: './stay-info.component.html',
  styleUrls: ['./stay-info.component.scss']
})
export class StayInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  now_date = getStreamNowDate();
  sub: Subscription[] = [];
  now_date_obj: nowDate = getNowDateObject(
    new Date(),
    this.languageService.language
  );

  focusIndex = 0;
  rentalIndex = 0;
  lang: 'jpn' | 'eng';
  sidebar: SideBar<AppListSideBarTiTleJpn, AppListSideBarTiTleEng>[] = [
    {
      title: '貸出し備品',
      title_jpn: '貸出し備品',
      title_eng: 'Borrowing items',
      key_code: '1',
      checked: false,
      focused: false
    },
    {
      title: 'レンタサイクル',
      title_jpn: 'レンタサイクル',
      key_code: '2',
      title_eng: 'Bicycle rental',
      checked: false,
      focused: false
    },
    {
      title: 'モーニングコール',
      title_jpn: 'モーニングコール',
      title_eng: 'Wake-up call',
      key_code: '3',
      checked: false,
      focused: false
    },
    {
      title: '客室マッサージ',
      title_jpn: '客室マッサージ',
      title_eng: 'Massage',
      key_code: '4',
      checked: false,
      focused: false
    },
    {
      title: 'レイトチェックアウト',
      title_jpn: 'レイトチェックアウト',
      title_eng: 'CheckOut',
      key_code: '5',
      checked: false,
      focused: false
    },

    {
      title: 'メニューへ戻る',
      title_jpn: 'メニューへ戻る',
      title_eng: 'Back to menu',
      key_code: '92',
      checked: false,
      focused: false
    }
  ];
  rental: Rental[] = require('./rental.json');
  appname: string;
  constructor(
    private roomNoService: RoomNoService,
    private router: Router,
    private languageService: LanguageService,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit() {
    (<any>document.querySelectorAll('.tab_menu_li')[this.focusIndex]).focus();
  }

  ngOnInit() {
    // 現在時刻の表示
    this.sub.push(
      this.now_date.subscribe(d => {
        this.now_date_obj = getNowDateObject(d, this.languageService.language);
      })
    );

    //URLパラーメータを取得するよ
    this.route.queryParamMap.subscribe(params => {
      if (params) {
        this.rentalIndex = Number(params.get('page'));
        this.setFocusIndex(Number(params.get('page')));
      }
    });

    // Languageをサービスしちゃう
    this.lang = this.languageService.language;
    if (this.languageService.language === 'jpn') {
      this.appname = 'ゲストサービス';
      return;
    } else {
      this.appname = 'Guest Service';
    }
    this.sidebar = this.sidebar.map(d => {
      d.title = d.title_eng;
      return d;
    });
    this.rental = this.rental.map(d => {
      return {
        name: d.name_en,
        name_jp: d.name_jp,
        name_en: d.name_en,
        icon_url: d.icon_url
      };
    });
  }

  ngOnDestroy() {
    this.sub.forEach(d => d.unsubscribe());
  }

  setFocusIndex(index: number) {
    //this.controlShow = true;
    this.focusIndex = index;
    this.sidebar.forEach(d => (d.checked = false));
    this.sidebar[this.focusIndex].checked = true;
    if (index != 5) {
      this.focusIndex = index;
      this.rentalIndex = index;
    }
  }

  setClickIndex(index: number) {
    //this.controlShow = true;
    if (index === 5) {
      this.router.navigate(['/room', this.roomNoService.room_no]);
    }
  }
}

type AppListSideBarTiTleJpn =
  | '貸出し備品'
  | 'レンタサイクル'
  | 'モーニングコール'
  | '客室マッサージ'
  | 'レイトチェックアウト';

type AppListSideBarTiTleEng =
  | 'Borrowing items'
  | 'Wake-up call'
  | 'Bicycle rental'
  | 'Massage'
  | 'CheckOut';

declare function require(x: string): any;
